import type { CSSProperties } from 'react'
import type { AnswerInputProps } from '../QuestionRenderer'

export function TimeInput({ question, value, onChange, onSubmit }: AnswerInputProps<string>) {
  const timeStep = Number(question.settings.timeStepMinutes ?? 1) * 60
  const hint = question.settings.placeholder ?? '09:30'

  return (
    <div className="flex max-w-sm flex-col gap-2">
      <input
        type="time"
        value={value ?? ''}
        min={question.settings.timeMin}
        max={question.settings.timeMax}
        step={Number.isFinite(timeStep) && timeStep > 0 ? timeStep : undefined}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') onSubmit()
        }}
        className="w-full rounded-md border bg-white px-4 py-3 text-xl outline-none transition focus:ring-2"
        style={
          {
            borderColor: 'color-mix(in srgb, var(--form-accent,#6366F1) 34%, transparent)',
            borderRadius: 'var(--form-radius,8px)',
            color: 'var(--form-answer,#334155)',
            fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
            fontSize: 'var(--form-input-size,1.25rem)',
            lineHeight: 'var(--form-line-height,1.55)',
            '--tw-ring-color': 'var(--form-accent,#6366F1)',
          } as CSSProperties
        }
      />
      <p
        className="text-sm"
        style={{
          color: 'var(--form-answer,#64748B)',
          fontSize: 'var(--form-meta-size,0.9375rem)',
        }}
      >
        請選擇時間，格式為 24 小時制，例如 {hint}。
        {question.settings.timeMin ? ` 最早 ${question.settings.timeMin}` : ''}
        {question.settings.timeMax ? `，最晚 ${question.settings.timeMax}` : ''}
      </p>
    </div>
  )
}
